import Link from "../../utils/Link";
import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";
import { buildURL } from "../../utils/buildURL";
import Button from "../Button";

const Buttons = ({ data }) => {
  const styles = {
    Center: { display: "flex", justifyContent: "center" },
    Start: { display: "flex", justifyContent: "flex-start" },
    End: { display: "flex", justifyContent: "flex-end" },
  };

  const { userLanguage } = useContext(LanguageContext);
  return (
    <div style={styles[data.alignment]}>
      {data.linksList.map(
        ({
          label,
          backgroundColor,
          textColor,
          linkType,
          url,
          article,
          icon,
        }) => (
          <Button color={backgroundColor}>
            <Link
              style={{ color: textColor || "white", textDecoration: "none" }}
              target={linkType === "External" && "__blank"}
              to={url || (article ?`/${buildURL(article.category)}/${article.slug}` : '')}
            >
              <div
                style={{
                  display: "flex",
                  alignContent: "center",
                  alignItems: "center",
                  flexDirection:
                    icon && icon.position === "End" ? "row-reverse" : "row",
                }}
              >
                {icon && (
                  <i
                    style={{ margin: "0px 5px" }}
                    className={`fa fa-${icon.icon}`}
                  />
                )}
                <font>
                  <font>{text(label, userLanguage)}</font>
                </font>
              </div>
            </Link>
          </Button>
        )
      )}
    </div>
  );
};

export default Buttons;
